import { render, staticRenderFns } from "./btn-quarternary2.vue?vue&type=template&id=6fc5b146&scoped=true&"
import script from "./btn-quarternary2.vue?vue&type=script&lang=js&"
export * from "./btn-quarternary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5b146",
  null
  
)

export default component.exports